import moment from 'moment';
import { Card, Row, Col } from 'react-bootstrap';
import "./Quote.scss"
import HelperService from '../utility/HelperService';

interface propData {
    data: any;
    amount?: number;
}

const SalesQuoteQuote = (props: propData) => {
    const amount = props.amount ?? props.data?.quoteAmount;
    return (
        <>
            <div>
                <Card className="card-style form-style p-4" style={{ marginBottom: 10 }}>
                    <Row>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Name</p>
                            <p className="font-14 mb-0">{props?.data?.jobName ? props?.data?.jobName : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Description</p>
                              <p className="font-14 mb-0">{props?.data?.jobDescription ? props?.data?.jobDescription : '-'}</p>
                        </Col>
                    </Row>
                </Card>
            </div>
             <div>
                <Card className="card-style form-style p-4" >
                     <Row>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote #</p>
                            <p className="font-14 mb-0">{props?.data?.quoteNum ? props?.data?.quoteNum : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Date</p>
                            <p className="font-14 mb-0">{props?.data?.proposalDate ? moment(props?.data?.proposalDate).format('MM/DD/YY') : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Amount</p>
                            <p className="font-14 mb-0">{amount !== null && amount !== undefined && amount !== '' ? "$" + HelperService.getCurrencyFormatter(amount) : '-'}</p>
                        </Col>
                    </Row>
                </Card>
            </div>

        </>
    )
}

export default SalesQuoteQuote;